import React from "react";

import { accepted_payments } from "repoV2/features/Payments/Payments.constants";
import styles from "./AcceptedPayments.module.scss";

const AcceptedPayments = () => {
    return (
        <div className={styles.paymentContainerStyle}>
            <div className={styles.paymentImageTextStyle}>
                ACCEPTED PAYMENTS
            </div>
            <div className={styles.cardImageContainer}>
                {accepted_payments.map(paymentType => (
                    <img
                        key={paymentType.id}
                        src={paymentType.src}
                        alt={paymentType.alt}
                        className={styles.cardImageStyle}
                        loading="lazy"
                    />
                ))}
            </div>
        </div>
    );
};

export default AcceptedPayments;
